import { sum } from 'lodash';

/**
 * Converts persisted column widths from grid units into rendered pixel widths.
 */
export const convertColWidthsGUtoPx = (
    colWidthsGU: number[],
    gridSize: number,
    resizeToWidth: number | null = null,
): number[] => {
    const sumOfColsGu = sum(colWidthsGU);
    const sumOfColsPx = sumOfColsGu * gridSize;
    const nCols = colWidthsGU.length;

    const resizeThresholdGu = 10;
    const resizeThresholdPx = resizeThresholdGu * gridSize;

    const shouldResizeToFit = resizeToWidth && sumOfColsPx < resizeToWidth + resizeThresholdPx;
    const multiplier = shouldResizeToFit && resizeToWidth ? (resizeToWidth + 2) / sumOfColsGu : gridSize;

    return colWidthsGU.reduce<number[]>((acc, colWidthGU, index) => {
        if (index === nCols - 1) {
            acc.push(sumOfColsGu * multiplier - sum(acc) - 2);
            return acc;
        }

        acc.push(Math.round(colWidthGU * multiplier));
        return acc;
    }, []);
};
